import React from 'react';
import { FacebookIcon, TwitterIcon, LinkedinIcon, InstagramIcon } from 'lucide-react';
export function Footer({
  onNavigate
}: {
  onNavigate?: (page: string) => void;
}) {
  return <footer className="bg-slate-900 pt-16 pb-8 border-t border-slate-800" data-id="element-45">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-46">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-47">
          {/* Column 1: Brand */}
          <div className="col-span-1 lg:col-span-1" data-id="element-48">
            <a href="#" className="block mb-4" data-id="element-49">
              <img src="https://cdn.magicpatterns.com/uploads/pEd3egThTWpVgMyyVxGfbc/ambient-telecom-logoo.png" alt="Ambient Telecom Solutions" className="h-10 w-auto" data-id="element-50" />
            </a>
            <p className="text-slate-400 mb-6 leading-relaxed" data-id="element-51">
              Your telecom expense reduction partner. We audit bills, negotiate
              better rates, and continuously optimize your telecom spend so you
              never overpay.
            </p>
            <div className="flex space-x-4" data-id="element-52">
              <a href="#" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-primary hover:text-white transition-colors" data-id="element-53">
                <LinkedinIcon className="w-5 h-5" data-id="element-54" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-primary hover:text-white transition-colors" data-id="element-55">
                <TwitterIcon className="w-5 h-5" data-id="element-56" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-primary hover:text-white transition-colors" data-id="element-57">
                <FacebookIcon className="w-5 h-5" data-id="element-58" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-primary hover:text-white transition-colors" data-id="element-59">
                <InstagramIcon className="w-5 h-5" data-id="element-60" />
              </a>
            </div>
          </div>

          {/* Column 2: Services */}
          <div data-id="element-61">
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-62">
              Services
            </h4>
            <ul className="space-y-3" data-id="element-63">
              <li data-id="element-64">
                <button onClick={() => onNavigate?.('business-internet')} className="text-slate-400 hover:text-white transition-colors" data-id="element-65">
                  Business Internet
                </button>
              </li>
              <li data-id="element-66">
                <button onClick={() => onNavigate?.('ethernet-fiber')} className="text-slate-400 hover:text-white transition-colors" data-id="element-67">
                  Ethernet-Fiber
                </button>
              </li>
              <li data-id="element-68">
                <button onClick={() => onNavigate?.('network-security')} className="text-slate-400 hover:text-white transition-colors" data-id="element-69">
                  Network Security
                </button>
              </li>
              <li data-id="element-70">
                <button onClick={() => onNavigate?.('ucaas')} className="text-slate-400 hover:text-white transition-colors" data-id="element-71">
                  UCaaS Solutions
                </button>
              </li>
              <li data-id="element-72">
                <button onClick={() => onNavigate?.('business-phone')} className="text-slate-400 hover:text-white transition-colors" data-id="element-73">
                  Business Phone Systems
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3: Company */}
          <div data-id="element-74">
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-75">
              Company
            </h4>
            <ul className="space-y-3" data-id="element-76">
              <li data-id="element-77">
                <button onClick={() => onNavigate?.('about')} className="text-slate-400 hover:text-white transition-colors" data-id="element-78">
                  About Us
                </button>
              </li>
              <li data-id="element-79">
                <button onClick={() => onNavigate?.('suppliers')} className="text-slate-400 hover:text-white transition-colors" data-id="element-80">
                  Our Suppliers
                </button>
              </li>
              <li data-id="element-81">
                <button onClick={() => onNavigate?.('moving-soon')} className="text-slate-400 hover:text-white transition-colors" data-id="element-82">
                  Moving Soon
                </button>
              </li>
              <li data-id="element-83">
                <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-84">
                  Careers
                </a>
              </li>
              <li data-id="element-85">
                <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-86">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div data-id="element-87">
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-88">
              Contact Us
            </h4>
            <ul className="space-y-4" data-id="element-89">
              <li className="text-slate-400" data-id="element-90">
                <span className="block text-white font-medium mb-1" data-id="element-91">
                  Phone:
                </span>
                <a href="tel:+4105255284" className="hover:text-white transition-colors" data-id="element-92">
                  +410-525-5284
                </a>
              </li>
              <li className="text-slate-400" data-id="element-93">
                <span className="block text-white font-medium mb-1" data-id="element-94">
                  Email:
                </span>
                <a href="mailto:info@ambienttelecom.com" className="hover:text-white transition-colors" data-id="element-95">
                  info@ambienttelecom.com
                </a>
              </li>
              <li className="text-slate-400" data-id="element-96">
                <span className="block text-white font-medium mb-1" data-id="element-97">
                  Headquarters:
                </span>
                Maryland, USA
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center" data-id="element-98">
          <p className="text-slate-500 text-sm mb-4 md:mb-0" data-id="element-99">
            &copy; {new Date().getFullYear()} Ambient Telecom. All rights
            reserved.
          </p>
          <div className="flex space-x-6 text-sm" data-id="element-100">
            <a href="#" className="text-slate-500 hover:text-white transition-colors" data-id="element-101">
              Terms of Service
            </a>
            <a href="#" className="text-slate-500 hover:text-white transition-colors" data-id="element-102">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}